var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-09-21
 * @brief SIE 솔루션 카드 관리 개발
 *
 ********************************************************************/
import { useEffect, useMemo, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { useAsync } from "react-async";
import { loadingBoxState } from "../../../recoil/menuState";
import Editor from "react-quill";
import "react-quill/dist/quill.snow.css";
import { alertState } from "../../../recoil/assessmentState";
import { langId } from "../../../recoil/langState";
const formats = [
    "font",
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "align",
    "color",
    "background",
    "size",
    "h1",
];
export default function SolutionCard(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reload = useRecoilValue(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    //props
    const { handleOpenPop } = props;
    const [repop, setRepop] = useState(false);
    const [reEditpop, setReEditpop] = useState(false);
    const [item, setItem] = useState(null);
    const [isEnglish, setIsEnglish] = useState(false);
    const [popType, setPotType] = useState(0);
    useEffect(() => {
        //등록
        handleOpenPop("pop-add-card", _jsx(CardAddPop, { repop: repop, setRepop: setRepop, isEnglish: isEnglish, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (_e) => Close("pop-add-card") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        handleOpenPop("pop-edit-card", _jsx(CardEditPop, { item: item, reEditpop: reEditpop, setReEditpop: setReEditpop, isEnglish: isEnglish, setIsEnglish: setIsEnglish, popType: popType, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (_e) => CUTIL.jsclose_Popup("pop-edit-card") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { item: item }));
    }, [repop, isEnglish, item, reEditpop, popType]);
    function Close(id) {
        setRepop(true);
        setReEditpop(true);
        CUTIL.jsclose_Popup(id);
    }
    const [cardItem, setCardItem] = useState([]);
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    let appPath = "";
    if (sortData.sortField) {
        appPath = appPath + `?sort=${sortData.sortField},${sortData.sort}`;
    }
    // 대그룹 목록 조회
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyconsulting/solutions${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCardItem(data.body);
            }
            else {
            }
        }
    }, [data]);
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    function CardAdd(e, type, item) {
        setIsEnglish(type);
        CUTIL.jsopen_Popup(e);
        // if (type) {
        //   setItem(item)
        // }
    }
    function CardEditpop(e, list, type, state) {
        return __awaiter(this, void 0, void 0, function* () {
            setIsEnglish(type);
            setPotType(state);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/energyconsulting/solution/${list.solutionId}`,
                appQuery: {
                    langId: !type ? 1 : 2,
                    // 신규 작업 시 langId 입력하기
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setItem(Object.assign(Object.assign({}, data.body), { solutionId: list.solutionId }));
                    CUTIL.jsopen_Popup(e);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setIsEnglish(type);
                    setPotType(state);
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uC194\uB8E8\uC158 \uCE74\uB4DC \uAD00\uB9AC" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-add-card", onClick: (e) => CardAdd(e, false, null) }, { children: _jsx("span", { children: "\uC194\uB8E8\uC158 \uCE74\uB4DC \uCD94\uAC00" }) })) })) })), _jsx("div", Object.assign({ className: "tbl-list" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uB300\uADF8\uB8F9,\uB0B4\uC6A9,\uC218\uC815,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC194\uB8E8\uC158 \uCE74\uB4DC \uAD00\uB9AC \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC194\uB8E8\uC158 \uCE74\uB4DC \uAD00\uB9AC \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "4%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "22%" } }), _jsx("col", { style: { width: "4%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "solutionName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (_e) => onClickSort("solutionName") }, { children: _jsx("span", { children: "\uC194\uB8E8\uC158 \uBA85" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "isEnglish" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (_e) => onClickSort("isEnglish") }, { children: _jsx("span", Object.assign({ className: "center" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC81C\uACF5\uD68C\uC0AC\uBA85" })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "bigGroupName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (_e) => onClickSort("bigGroupName") }, { children: _jsx("span", { children: "\uB300\uADF8\uB8F9" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "middleGroupName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (_e) => onClickSort("middleGroupName") }, { children: _jsx("span", { children: "\uC911\uADF8\uB8F9" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "smallGroupName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (_e) => onClickSort("smallGroupName") }, { children: _jsx("span", { children: "\uC18C\uADF8\uB8F9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uD575\uC2EC \uD0A4\uC6CC\uB4DC" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uD0DC\uADF8" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uC0AD\uC81C" }))] }) }), _jsx("tbody", { children: cardItem &&
                                            cardItem.map((list, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "js-open", "data-pop": "pop-edit-card" }, { children: idx + 1 })), _jsx("td", { children: _jsxs("a", Object.assign({ href: "#", className: "js-open", "data-pop": "pop-edit-card", onClick: (e) => {
                                                                e.preventDefault(), CardEditpop(e, list, false, 0);
                                                            } }, { children: [" ", list.solutionName] })) }), !list.isEnglish ? (_jsx("td", { children: _jsxs("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-edit-card", onClick: (e) => CardEditpop(e, list, true, 1) }, { children: [_jsx("span", Object.assign({ className: "hoverno-txt", "data-pop": "pop-edit-card" }, { children: "\uB0B4\uC6A9\uC5C6\uC74C" })), _jsx("span", Object.assign({ className: "hover-txt", "data-pop": "pop-edit-card" }, { children: "\uC124\uC815" }))] })) })) : (_jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no hover-blue js-open", "data-pop": "pop-edit-card", onClick: (e) => CardEditpop(e, list, true, 0) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-edit-card" }, { children: "\uC218\uC815" })) })) })), _jsx("td", Object.assign({ className: "js-open", "data-pop": "pop-edit-card" }, { children: list.companyName })), _jsx("td", Object.assign({ className: "js-open", "data-pop": "pop-edit-card" }, { children: list.bigGroup.name })), _jsx("td", Object.assign({ className: "js-open", "data-pop": "pop-edit-card" }, { children: list.middleGroup.name })), _jsx("td", Object.assign({ className: "js-open", "data-pop": "pop-edit-card" }, { children: list.smallGroup.name })), _jsx("td", Object.assign({ className: "txt-top js-open", "data-pop": "pop-edit-card" }, { children: _jsx("p", Object.assign({ className: "keywordlist" }, { children: _jsx("span", { children: list.extraInfo ? list.extraInfo : "-" }) })) })), _jsx("td", Object.assign({ className: "txt-top js-open", "data-pop": "pop-edit-card", onClick: (e) => CardEditpop(e, list, false, 0) }, { children: _jsx("ul", Object.assign({ className: "labellist" }, { children: list.solutionTag.length > 0
                                                                ? list.solutionTag.map((tag, i) => (_jsx("li", { children: _jsxs("span", { children: ["#", tag] }) }, "hastagList_" + i.toString())))
                                                                : "" })) })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => CardEditpop(e, list, false, 0) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }, "cardList_" + idx.toString()))) })] })) }))] }))] })) }));
}
function CardAddPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    // props
    const { repop, setRepop, isEnglish } = props;
    // Editor DOM 선택용
    const editorRef = useRef(null);
    //
    const fileRef = useRef();
    //
    const [errorList, setErrorList] = useState([]);
    const [solutionName, setSolutionName] = useState("");
    const [solutionSubTitle, setSolutionSubTitle] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [defaultImg, setDefaultImg] = useState(null);
    const [bigGroupItem, setBigGroupItem] = useState([]);
    const [bigGroup, setBigGroup] = useState(null);
    const [middleGroupItem, setMiddleGroupItem] = useState([]);
    const [middleGroup, setMiddleGroup] = useState(null);
    const [smallGroupItem, setSmallGroupItem] = useState([]);
    const [smallGroup, setSmallGroup] = useState(null);
    const [extraInfo, setExtraInfo] = useState("");
    const [hashTag, setHashTag] = useState("");
    const [tags, setTags] = useState([]);
    const [description, setDescription] = useState("");
    const [lsBest, setLsBest] = useState(true);
    const [content, setContent] = useState("");
    const [file, setFile] = useState([]);
    const lastNum = 10;
    useEffect(() => {
        if (repop) {
            Close("pop-add-card");
        }
    }, [repop]);
    // 에디터 튤바 설정
    const modules = useMemo(() => ({
        toolbar: {
            // container에 등록되는 순서대로 tool 배치
            container: [
                //[{ 'font': [] }],  font 설정
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }], // 리스트,  {'indent': '-1'}, {'indent': '+1'} 인덴트 설정
                // ['link', 'image', 'video'], // 링크, 이미지, 비디오 업로드 설정
                // [{ 'align': [] }, { 'color': [] }, { 'background': [] }], // 정렬, 글씨 색깔, 글씨 배경색 설정
                // ['clean'], // toolbar 설정 초기화 설정
            ],
        },
    }), []);
    // 솔루션 명
    function onChangeSolutionName(e) {
        setErrorList(errorList.filter((err) => err.field !== "solutionName"));
        setSolutionName(e.target.value);
    }
    // 솔루션 소제목
    function onChangeSolutionSubTitle(e) {
        setSolutionSubTitle(e.target.value);
    }
    // 회사명
    function onChangeCompanyName(e) {
        setErrorList(errorList.filter((err) => err.field !== "companyName"));
        setCompanyName(e.target.value);
    }
    // 첨부파일
    function handleFileUpload(_e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function DefaultFileImage(e) {
        const file = e.target.files[0];
        setDefaultImg(file);
        e.target.value = "";
    }
    // 이미지 삭제
    function DeleteFile(_e) {
        setDefaultImg(null);
    }
    // 대그룹 선택
    function BigGroupSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/energyconsulting/biggroups`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setBigGroupItem(data.body);
                }
                else {
                    // need error handle
                    /* setAlert({
                      ...alert,
                      type: CONST.TYPE_NONE,
                      divTag: data.errorList.map((err) => err.msg),
                    });
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
                }
            }
        });
    }
    // 선태한 대그룹
    function BigGroupClick(list) {
        setErrorList(errorList.filter((err) => err.field !== "bigGroupId"));
        if (bigGroup && bigGroup.id !== list.id) {
            setMiddleGroupItem([]);
            setMiddleGroup(null);
            setSmallGroupItem([]);
            setSmallGroup(null);
        }
        setBigGroup(list);
    }
    // 중그룹 선택
    function MiddleGroupSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (bigGroup) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/energyconsulting/middlegroups`,
                    appQuery: {
                        bigGroupId: bigGroup.id,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setMiddleGroupItem(data.body);
                    }
                    else {
                        // need error handle
                        /* setAlert({
                          ...alert,
                          type: CONST.TYPE_NONE,
                          divTag: data.errorList.map((err) => err.msg),
                        });
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
                    }
                }
            }
        });
    }
    // 선태한 중그룹
    function MiddleGroupClick(list) {
        setErrorList(errorList.filter((err) => err.field !== "middleGroupId"));
        if (middleGroup && middleGroup.id !== list.id) {
            setSmallGroupItem([]);
            setSmallGroup(null);
        }
        setMiddleGroup(list);
    }
    // 소그룹 선택
    function SmallGroupSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (middleGroup) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/energyconsulting/smallgroups`,
                    appQuery: {
                        middleGroupId: middleGroup.id,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setSmallGroupItem(data.body);
                    }
                    else {
                        // need error handle
                        /* setAlert({
                          ...alert,
                          type: CONST.TYPE_NONE,
                          divTag: data.errorList.map((err) => err.msg),
                        });
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
                    }
                }
            }
        });
    }
    // 선태한 소그룹
    function SmallGroupClick(list) {
        setErrorList(errorList.filter((err) => err.field !== "smallGroupId"));
        setSmallGroup(list);
    }
    // 핵심 키워드
    function onChangeExtraInfo(e) {
        setExtraInfo(e.target.value);
    }
    // 해쉬태그 만들기
    function HashTags(tag) {
        if (tags.length < 10) {
            if (tag.length > 0) {
                // 자동 # 만들기
                setTags([...tags, tag]);
                setHashTag("");
            }
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { divTag: "태그 추가 최대 범위는 10개입니다." }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    // 해쉬태그 삭제
    function DelTags(idx) {
        setTags(tags.filter((_, index) => index !== idx));
    }
    // 솔루션 설명
    function onChangeDescription(e) {
        setErrorList(errorList.filter((err) => err.field !== "description"));
        setDescription(e.target.value);
    }
    function LsBest(_e) {
        if (lsBest) {
            setLsBest(false);
        }
        else {
            setLsBest(true);
        }
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    // 카드 등록
    function CardSaved(_e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!bigGroup || !middleGroup || !smallGroup || !solutionName || !companyName || !description) {
                setErrorList([
                    !bigGroup && { field: "bigGroupId", msg: "필수 항목입니다." },
                    !middleGroup && { field: "middleGroupId", msg: "필수 항목입니다." },
                    !smallGroup && { field: "smallGroupId", msg: "필수 항목입니다." },
                    !solutionName && { field: "solutionName", msg: "필수 항목입니다." },
                    !companyName && { field: "companyName", msg: "필수 항목입니다." },
                    !description && { field: "description", msg: "필수 항목입니다." },
                ]);
            }
            else if (content == "<p><br></p>" || content == "") {
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-card", type: CONST.TYPE_ERROR, divTag: `상세 내용은 필수 항목입니다.` }));
                CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-card");
            }
            else {
                setRecoilIsLoadingBox(true);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/energyconsulting/solution`,
                    appQuery: {
                        smallGroupId: smallGroup.id,
                        solutionName: solutionName,
                        solutionSubTitle: solutionSubTitle,
                        companyName: companyName,
                        description: description,
                        extraInfo: extraInfo,
                        solutionTag: tags.filter((arr, index, callback) => index === callback.findIndex((txt) => txt === arr)),
                        content: content,
                        lsBest: lsBest,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        if (defaultImg) {
                            CardDefaultImages(data.body.solutionId);
                        }
                        else {
                            if (file.length > 0) {
                                CardImages(data.body.solutionId, true);
                            }
                            else {
                                setReload(true);
                                Close("pop-add-card");
                                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "등록 되었습니다." }));
                                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                                setReload(false);
                                setRecoilIsLoadingBox(false);
                            }
                        }
                    }
                    else {
                        // need error handle
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function CardDefaultImages(solutionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("file", defaultImg);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/image/solution?solutionId=${solutionId}&langId=${langIds}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        CardImages(solutionId, true);
                    }
                    else {
                        setReload(true);
                        Close("pop-add-card");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "등록 되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    if (file.length > 0) {
                        CardImages(solutionId, false);
                    }
                    else {
                        Close("pop-add-card");
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "서버 오류로 인하여 카드는 등록 되었으나 대표이미지는 재등록 해주세요." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    // 상세 이미지
    function CardImages(solutionId, blooen) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/solution/card?solutionId=${solutionId}&langId=${langIds}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    Close("pop-add-card");
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: blooen == true
                            ? "등록 되었습니다."
                            : "솔루션카드 내용과 상세내용 이미지가 등록되었으나, 서버 오류로 인하여 대표이미지는 재등록 해주세요." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
            }
            else {
                // need error handle
                setReload(false);
                Close("pop-add-card");
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: blooen == true
                        ? "대표 이미지를 제외한 솔루션카드,상세내용 이미지가 등록되었습니다."
                        : "서버 오류로 인하여 카드는 등록 되었으나 대표이미지와 상세 내용 이미지는 재등록 해주세요." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setReload(false);
                setRecoilIsLoadingBox(false);
            }
        });
    }
    function Close(id) {
        setErrorList([]);
        setSolutionName("");
        setSolutionSubTitle("");
        setCompanyName("");
        setDefaultImg(null);
        setFile([]);
        setBigGroupItem([]);
        setBigGroup(null);
        setMiddleGroupItem([]);
        setMiddleGroup(null);
        setSmallGroupItem([]);
        setSmallGroup(null);
        setExtraInfo("");
        setHashTag("");
        setTags([]);
        setDescription("");
        setLsBest(true);
        setContent("");
        CUTIL.jsclose_Popup(id);
        setRepop(false);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body pt-0" }, { children: _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input mt-0" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC194\uB8E8\uC158 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field === "solutionName").length > 0 ? " input-error" : ""}`, value: solutionName, onChange: (e) => onChangeSolutionName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "solutionName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC194\uB8E8\uC158 \uC18C\uC81C\uBAA9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: solutionSubTitle, onChange: (e) => onChangeSolutionSubTitle(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC81C\uACF5\uD68C\uC0AC \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field === "companyName").length > 0 ? " input-error" : ""}`, value: companyName, onChange: (e) => onChangeCompanyName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companyName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: "\uB300\uD45C \uC774\uBBF8\uC9C0" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: "\uD074\uB9AD\uD558\uC5EC \uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }), _jsx("label", Object.assign({ onClick: (e) => handleFileUpload(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file", ref: fileRef, accept: "image/*", onChange: (e) => DefaultFileImage(e) })] })), _jsxs("p", Object.assign({ className: "txt-info" }, { children: ["\uC194\uB8E8\uC158 \uCE74\uB4DC \uBAA9\uB85D\uC5D0 \uD45C\uC2DC\uB418\uB294 \uC774\uBBF8\uC9C0\uC785\uB2C8\uB2E4.", _jsx("br", {}), "\uD30C\uC77C 1\uAC1C \uC5C5\uB85C\uB4DC \uAC00\uB2A5 / \uAD8C\uC7A5 300px * 300px \uC774\uC0C1"] })), _jsx("ul", Object.assign({ className: "filelist" }, { children: defaultImg && (_jsxs("li", { children: [_jsx("span", { children: defaultImg.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => DeleteFile(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })) }))] }))] })] })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 mt-24 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uB300\uADF8\uB8F9" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select big ${errorList.filter((err) => err.field === "bigGroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => BigGroupSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: bigGroup && bigGroup.id > 0 ? bigGroup.name : "대그룹" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: bigGroupItem.length > 0 ? (bigGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (_e) => BigGroupClick(list) }, { children: list.name }), "bigAdd_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "option" }, { children: "\uC5C6\uC74C" }))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "bigGroupId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC911\uADF8\uB8F9" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select middle ${errorList.filter((err) => err.field === "middleGroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => MiddleGroupSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: middleGroup && middleGroup.id > 0 ? middleGroup.name : "중그룹" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: middleGroupItem.length > 0 ? (middleGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (_e) => MiddleGroupClick(list) }, { children: list.name }), "middleAdd_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "option" }, { children: "\uC5C6\uC74C" }))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "middleGroupId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC18C\uADF8\uB8F9" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select small ${errorList.filter((err) => err.field === "smallGroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => SmallGroupSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: smallGroup && smallGroup.id > 0 ? smallGroup && smallGroup.name : "소그룹" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: smallGroupItem.length > 0 ? (smallGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (_e) => SmallGroupClick(list) }, { children: list.name }), "smallAdd_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "option" }, { children: "\uC5C6\uC74C" }))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "smallGroupId").map((err) => err.msg) }))] }))] })] })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 mt-24 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD575\uC2EC \uD0A4\uC6CC\uB4DC" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h66", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: extraInfo, onChange: (e) => onChangeExtraInfo(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uAD00\uB828 \uD0DC\uADF8" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "flex-inline" }, { children: [_jsx("input", { type: "text", placeholder: "\uD0DC\uADF8\uC785\uB825(\uCD5C\uB300 10\uAC1C)", className: "wcal-66", value: hashTag, onChange: (e) => setHashTag(e.target.value) }), _jsx("button", Object.assign({ type: "button", className: "btn btn-add ml-8 w32", onClick: (_e) => HashTags(hashTag) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD0DC\uADF8 \uCD94\uAC00" })) }))] })), _jsx("ul", Object.assign({ className: "labellist mt-16" }, { children: tags
                                                                .filter((arr, index, callback) => index === callback.findIndex((txt) => txt === arr))
                                                                .map((name, idx) => (_jsxs("li", { children: [_jsx("span", { children: "#" + name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (_e) => DelTags(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "tagAdd_" + idx.toString()))) }))] }))] })] }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-1-2-5" }, { children: [_jsx("h2", Object.assign({ className: "star" }, { children: "\uC194\uB8E8\uC158 \uC124\uBA85" })), _jsx("ul", Object.assign({ className: "form__input brd-top-1 mt-26 pt-24" }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: `h122 ${errorList.filter((err) => err.field === "description").length > 0 ? " input-error" : ""}`, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: description, onChange: (e) => onChangeDescription(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "description").map((err) => err.msg) })), _jsxs("div", Object.assign({ className: "mt-16" }, { children: [_jsx("input", { type: "checkbox", id: "t_1", checked: lsBest ? true : false, onChange: (e) => LsBest(e) }), _jsx("label", Object.assign({ htmlFor: "t_1" }, { children: _jsx("span", { children: "LS Best \uC194\uB8E8\uC158\uC73C\uB85C \uC124\uC815\uD569\uB2C8\uB2E4." }) }))] }))] })) }) })), _jsx("h2", Object.assign({ className: "star mt-56" }, { children: "\uC0C1\uC138\uB0B4\uC6A9" })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 mt-26 pt-24" }, { children: [_jsx("li", { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("div", Object.assign({ className: "h267" }, { children: _jsx(Editor, { value: content, 
                                                        // className="h267"
                                                        style: { height: "280px" }, theme: "snow", placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.", modules: modules, formats: formats, onChange: (_content, _delta, _source, editor) => setContent(editor.getHTML()) }) })) })) }), _jsx("li", Object.assign({ className: "mt-16" }, { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: "\uC0AC\uC9C4\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file2" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file2", accept: "image/*", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "\uC194\uB8E8\uC158 \uC0C1\uC138 \uD654\uBA74\uC5D0\uC11C \uD45C\uC2DC\uB418\uB294 \uC774\uBBF8\uC9C0\uB85C \uACE0\uD574\uC0C1\uB3C4 \uC774\uBBF8\uC9C0\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4. \uB4F1\uB85D\uB41C \uC774\uBBF8\uC9C0\uB294 \uB9AC\uC0AC\uC774\uC9D5 \uD574 \uBCF4\uC5EC\uC9D1\uB2C8\uB2E4. (\uAD8C\uC7A5 \uD06C\uAE30: 400KB\uC774\uC0C1/ \uD574\uC0C1\uB3C4 : 1500x1000 \uD53D\uC140 \uC774\uC0C1)" })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (_e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imagesAdd_" + idx.toString()))) }))] })) }))] }))] }))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (_e) => Close("pop-add-card") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => CardSaved(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
function CardEditPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { item, reEditpop, setReEditpop, isEnglish, popType } = props;
    // Editor DOM 선택용
    const editorRef = useRef(null);
    //
    const fileRef = useRef();
    //
    const [errorList, setErrorList] = useState([]);
    const [solutionName, setSolutionName] = useState("");
    const [solutionSubTitle, setSolutionSubTitle] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [defaultImg, setDefaultImg] = useState(null);
    const [bigGroupItem, setBigGroupItem] = useState([]);
    const [bigGroup, setBigGroup] = useState(null);
    const [middleGroupItem, setMiddleGroupItem] = useState([]);
    const [middleGroup, setMiddleGroup] = useState(null);
    const [smallGroupItem, setSmallGroupItem] = useState([]);
    const [smallGroup, setSmallGroup] = useState(null);
    const [extraInfo, setExtraInfo] = useState("");
    const [hashTag, setHashTag] = useState("");
    const [tags, setTags] = useState([]);
    const [description, setDescription] = useState("");
    const [lsBest, setLsBest] = useState(true);
    const [file, setFile] = useState([]);
    const [content, setContent] = useState("");
    const lastNum = 10;
    let imteId = popType < 2 ? item : item && item.solutionId;
    useEffect(() => {
        if (item) {
            setErrorList([]);
            setSolutionName(item.solutionName ? item.solutionName : "");
            setSolutionSubTitle(item.solutionSubTitle ? item.solutionSubTitle : "");
            setCompanyName(item.companyName ? item.companyName : "");
            setDefaultImg(item.imageUrl ? { name: item.imageFileName, url: item.imageUrl } : null);
            setFile(item.imageList.length > 0 ? item.imageList : []);
            setBigGroupItem([]);
            setBigGroup(item.bigGroup ? item.bigGroup : null);
            setMiddleGroupItem([]);
            setMiddleGroup(item.middleGroup ? item.middleGroup : null);
            setSmallGroupItem([]);
            setSmallGroup(item.smallGroup ? item.smallGroup : null);
            setExtraInfo(item.extraInfo ? item.extraInfo : "");
            setHashTag("");
            setTags(item.solutionTag.length > 0 ? item.solutionTag : []);
            setDescription(item.description ? item.description : "");
            setLsBest(item.lsBest ? item.lsBest : true);
            setContent(item.content ? item.content : "");
        }
        if (reEditpop) {
            Close("pop-edit-card");
        }
    }, [imteId, reEditpop, isEnglish, popType]);
    // 에디터 튤바 설정
    const modules = useMemo(() => ({
        toolbar: {
            // container에 등록되는 순서대로 tool 배치
            container: [
                //[{ 'font': [] }],  font 설정
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }], // 리스트,  {'indent': '-1'}, {'indent': '+1'} 인덴트 설정
                // ['link', 'image', 'video'], // 링크, 이미지, 비디오 업로드 설정
                // [{ 'align': [] }, { 'color': [] }, { 'background': [] }], // 정렬, 글씨 색깔, 글씨 배경색 설정
                // ['clean'], // toolbar 설정 초기화 설정
            ],
        },
    }), []);
    // 솔루션 명
    function onChangeSolutionName(e) {
        setErrorList(errorList.filter((err) => err.field !== "solutionName"));
        setSolutionName(e.target.value);
    }
    // 솔루션 소제목
    function onChangeSolutionSubTitle(e) {
        setSolutionSubTitle(e.target.value);
    }
    // 회사명
    function onChangeCompanyName(e) {
        setErrorList(errorList.filter((err) => err.field !== "companyName"));
        setCompanyName(e.target.value);
    }
    // 첨부파일
    function handleFileUpload(_e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function DefaultFileImage(e) {
        const file = e.target.files[0];
        setDefaultImg(file);
        e.target.value = "";
    }
    // 이미지 삭제
    function DeleteFile(_e) {
        setDefaultImg(null);
    }
    // 대그룹 선택
    function BigGroupSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/energyconsulting/biggroups`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setBigGroupItem(data.body);
                }
                else {
                    // need error handle
                    /* setAlert({
                      ...alert,
                      type: CONST.TYPE_NONE,
                      divTag: data.errorList.map((err) => err.msg),
                    });
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
                }
            }
        });
    }
    // 선태한 대그룹
    function BigGroupClick(list) {
        setErrorList(errorList.filter((err) => err.field !== "bigGroupId"));
        if (bigGroup && bigGroup.id !== list.id) {
            setMiddleGroupItem([]);
            setMiddleGroup(null);
            setSmallGroupItem([]);
            setSmallGroup(null);
        }
        setBigGroup(list);
    }
    // 중그룹 선택
    function MiddleGroupSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (bigGroup) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/energyconsulting/middlegroups`,
                    appQuery: {
                        bigGroupId: bigGroup.id,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setMiddleGroupItem(data.body);
                    }
                    else {
                        // need error handle
                        /* setAlert({
                          ...alert,
                          type: CONST.TYPE_NONE,
                          divTag: data.errorList.map((err) => err.msg),
                        });
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
                    }
                }
            }
        });
    }
    // 선태한 중그룹
    function MiddleGroupClick(list) {
        setErrorList(errorList.filter((err) => err.field !== "middleGroupId"));
        if (middleGroup && middleGroup.id !== list.id) {
            setSmallGroupItem([]);
            setSmallGroup(null);
        }
        setMiddleGroup(list);
    }
    // 소그룹 선택
    function SmallGroupSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (middleGroup) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/energyconsulting/smallgroups`,
                    appQuery: {
                        middleGroupId: middleGroup.id,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setSmallGroupItem(data.body);
                    }
                    else {
                        // need error handle
                        /* setAlert({
                          ...alert,
                          type: CONST.TYPE_NONE,
                          divTag: data.errorList.map((err) => err.msg),
                        });
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
                    }
                }
            }
        });
    }
    // 선태한 소그룹
    function SmallGroupClick(list) {
        setErrorList(errorList.filter((err) => err.field !== "smallGroupId"));
        setSmallGroup(list);
    }
    // 핵심 키워드
    function onChangeExtraInfo(e) {
        setExtraInfo(e.target.value);
    }
    // 해쉬태그 만들기
    function HashTags(tag) {
        if (tags.length < 10) {
            if (tag.length > 0) {
                // 자동 # 만들기
                setTags([...tags, tag]);
                setHashTag("");
            }
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { divTag: "태그 추가 최대 범위는 10개입니다." }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    // 해쉬태그 삭제
    function DelTags(idx) {
        setTags(tags.filter((_, index) => index !== idx));
    }
    // 솔루션 설명
    function onChangeDescription(e) {
        setErrorList(errorList.filter((err) => err.field !== "description"));
        setDescription(e.target.value);
    }
    function LsBest(_e) {
        if (lsBest) {
            setLsBest(false);
        }
        else {
            setLsBest(true);
        }
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index, img) {
        if (img.imageId) {
            FileDelData(img.imageId, index);
        }
        else {
            setFile(file.filter((_, idx) => idx !== index));
        }
    }
    function FileDelData(imageId, index) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-card", type: CONST.TYPE_ERROR, divTag: data.body }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-card");
                    setFile(file.filter((_, idx) => idx !== index));
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-card", type: CONST.TYPE_ERROR, divTag: `서버 요류 입니다.` }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-card");
                }
            }
        });
    }
    // 카드 수정
    function CardSaved(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!bigGroup || !middleGroup || !smallGroup || !solutionName || !companyName || !description) {
                setErrorList([
                    !bigGroup && { field: "bigGroupId", msg: "필수 항목입니다." },
                    !middleGroup && { field: "middleGroupId", msg: "필수 항목입니다." },
                    !smallGroup && { field: "smallGroupId", msg: "필수 항목입니다." },
                    !solutionName && { field: "solutionName", msg: "필수 항목입니다." },
                    !companyName && { field: "companyName", msg: "필수 항목입니다." },
                    !description && { field: "description", msg: "필수 항목입니다." },
                ]);
            }
            else if (content == "<p><br></p>" || content == "") {
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-card", type: CONST.TYPE_ERROR, divTag: `상세 내용은 필수 항목입니다.` }));
                CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-card");
            }
            else {
                setRecoilIsLoadingBox(true);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/energyconsulting/solution/${item.solutionId}`,
                    appQuery: {
                        smallGroupId: smallGroup.id,
                        solutionName: solutionName,
                        solutionSubTitle: solutionSubTitle,
                        companyName: companyName,
                        description: description,
                        extraInfo: extraInfo,
                        solutionTag: tags.filter((arr, index, callback) => index === callback.findIndex((txt) => txt === arr)),
                        content: content,
                        lsBest: !isEnglish ? lsBest : false,
                        langId: !isEnglish ? 1 : 2,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        if (defaultImg) {
                            if (!defaultImg.url) {
                                CardDefaultImages(data.body.solutionId);
                            }
                            else {
                                if (file.filter((img) => !img.imageId).length > 0) {
                                    CardImages(data.body.solutionId, true);
                                }
                                else {
                                    setReload(true);
                                    Close("pop-edit-card");
                                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: `${isEnglish && popType > 0 ? "영문이 등록" : isEnglish && popType > 0 ? "영문이 수정" : "수정"} 되었습니다.` }));
                                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                                    setReload(false);
                                    setRecoilIsLoadingBox(false);
                                }
                            }
                        }
                        else {
                            CardDefaultImages(data.body.solutionId);
                        }
                    }
                    else {
                        // need error handle
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    //대표 이미지
    function CardDefaultImages(solutionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("file", defaultImg);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/image/solution?solutionId=${solutionId}&langId=${!isEnglish ? 1 : 2}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.filter((img) => !img.imageId).length > 0) {
                        CardImages(solutionId, true);
                    }
                    else {
                        setReload(true);
                        Close("pop-edit-card");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: `${isEnglish && popType > 0 ? "영문이 등록" : "수정"} 되었습니다.` }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    if (file.filter((img) => !img.imageId).length > 0) {
                        CardImages(solutionId, false);
                    }
                    else {
                        Close("pop-edit-card");
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "서버 오류로 인하여 카드는 수정 되었으나 대표이미지는 재등록 해주세요." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    // 이미지 등록
    function CardImages(solutionId, blooen) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            // 파일 데이터 저장
            file.filter((img) => !img.imageId).map((files) => formData.append("files", files));
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/solution/card?solutionId=${solutionId}&langId=${!isEnglish ? 1 : 2}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    Close("pop-edit-card");
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: blooen == true
                            ? `${isEnglish && popType > 0 ? "영문이 등록" : "수정"} 되었습니다.`
                            : "솔루션카드 내용과 상세내용 이미지가 수정되었으나, 서버 오류로 인하여 대표이미지는 재등록 해주세요." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
            }
            else {
                // need error handle
                setReload(false);
                Close("pop-edit-card");
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: blooen == true
                        ? "대표 이미지를 제외한 솔루션카드,상세내용 이미지가 수정되었습니다."
                        : "서버 오류로 인하여 카드는 수정 되었으나 대표이미지와 상세 내용 이미지는 재등록 해주세요." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setReload(false);
                setRecoilIsLoadingBox(false);
            }
        });
    }
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setReEditpop(false);
        // setIsEnglish(false)
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body pt-0" }, { children: _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1" }, { children: [isEnglish && (_jsx("ul", Object.assign({ className: "form__input mt-0" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uB2E4\uAD6D\uC5B4 \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC601\uBB38" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option" }, { children: "\uC601\uBB38" })), _jsx("li", Object.assign({ className: "option" }, { children: "\uC911\uBB38" }))] })] })) }))] }) }))), _jsxs("ul", Object.assign({ className: `form__input ${isEnglish ? "brd-top-1 mt-24 pt-24" : ""}` }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC194\uB8E8\uC158 \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field === "solutionName").length > 0 ? " input-error" : ""}`, value: solutionName, onChange: (e) => onChangeSolutionName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "solutionName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC194\uB8E8\uC158 \uC18C\uC81C\uBAA9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: solutionSubTitle, onChange: (e) => onChangeSolutionSubTitle(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC81C\uACF5\uD68C\uC0AC \uBA85" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: `${errorList.filter((err) => err.field === "companyName").length > 0 ? " input-error" : ""}`, value: companyName, onChange: (e) => onChangeCompanyName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companyName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: "\uB300\uD45C \uC774\uBBF8\uC9C0" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: "\uD074\uB9AD\uD558\uC5EC \uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }), _jsx("label", Object.assign({ onClick: (e) => handleFileUpload(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file3", ref: fileRef, accept: "image/*", onChange: (e) => DefaultFileImage(e) })] })), _jsxs("p", Object.assign({ className: "txt-info" }, { children: ["\uC194\uB8E8\uC158 \uCE74\uB4DC \uBAA9\uB85D\uC5D0 \uD45C\uC2DC\uB418\uB294 \uC774\uBBF8\uC9C0\uC785\uB2C8\uB2E4.", _jsx("br", {}), "\uD30C\uC77C 1\uAC1C \uC5C5\uB85C\uB4DC \uAC00\uB2A5 / \uAD8C\uC7A5 300px * 300px \uC774\uC0C1"] })), _jsx("ul", Object.assign({ className: "filelist" }, { children: defaultImg && (_jsxs("li", { children: [_jsx("span", { children: defaultImg.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => DeleteFile(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })) }))] }))] })] })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 mt-24 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uB300\uADF8\uB8F9" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select big ${errorList.filter((err) => err.field === "bigGroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => !isEnglish && BigGroupSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: bigGroup && bigGroup.id > 0 ? bigGroup.name : "대그룹" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: bigGroupItem.length > 0 ? (bigGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (_e) => BigGroupClick(list) }, { children: list.name }), "bigAdd_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "option" }, { children: "\uC5C6\uC74C" }))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "bigGroupId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC911\uADF8\uB8F9" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select middle ${errorList.filter((err) => err.field === "middleGroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => !isEnglish && MiddleGroupSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: middleGroup && middleGroup.id > 0 ? middleGroup.name : "중그룹" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: middleGroupItem.length > 0 ? (middleGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (_e) => MiddleGroupClick(list) }, { children: list.name }), "middleAdd_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "option" }, { children: "\uC5C6\uC74C" }))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "middleGroupId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC18C\uADF8\uB8F9" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select small ${errorList.filter((err) => err.field === "smallGroupId").length > 0 ? " input-error" : ""}`, onClick: (e) => !isEnglish && SmallGroupSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: smallGroup && smallGroup.id > 0 ? smallGroup && smallGroup.name : "소그룹" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: smallGroupItem.length > 0 ? (smallGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (_e) => SmallGroupClick(list) }, { children: list.name }), "smallAdd_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "option" }, { children: "\uC5C6\uC74C" }))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "smallGroupId").map((err) => err.msg) }))] }))] })] })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 mt-24 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD575\uC2EC \uD0A4\uC6CC\uB4DC" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h66", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: extraInfo, onChange: (e) => onChangeExtraInfo(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uAD00\uB828 \uD0DC\uADF8" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "flex-inline" }, { children: [_jsx("input", { type: "text", placeholder: "\uD0DC\uADF8\uC785\uB825(\uCD5C\uB300 10\uAC1C)", className: "wcal-66", value: hashTag, onChange: (e) => setHashTag(e.target.value) }), _jsx("button", Object.assign({ type: "button", className: "btn btn-add ml-8 w32", onClick: (_e) => HashTags(hashTag) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD0DC\uADF8 \uCD94\uAC00" })) }))] })), _jsx("ul", Object.assign({ className: "labellist mt-16" }, { children: tags
                                                                .filter((arr, index, callback) => index === callback.findIndex((txt) => txt === arr))
                                                                .map((name, idx) => (_jsxs("li", { children: [_jsx("span", { children: "#" + name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (_e) => DelTags(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "tagAdd_" + idx.toString()))) }))] }))] })] }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-1-2-5" }, { children: [_jsx("h2", Object.assign({ className: "star" }, { children: "\uC194\uB8E8\uC158 \uC124\uBA85" })), _jsx("ul", Object.assign({ className: "form__input brd-top-1 mt-26 pt-24" }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: `h122 ${errorList.filter((err) => err.field === "description").length > 0 ? " input-error" : ""}`, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: description, onChange: (e) => onChangeDescription(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "description").map((err) => err.msg) })), !isEnglish && (_jsxs("div", Object.assign({ className: "mt-16" }, { children: [_jsx("input", { type: "checkbox", id: "t_2", checked: lsBest ? true : false, onChange: (e) => LsBest(e) }), _jsx("label", Object.assign({ htmlFor: "t_2" }, { children: _jsx("span", { children: "LS Best \uC194\uB8E8\uC158\uC73C\uB85C \uC124\uC815\uD569\uB2C8\uB2E4." }) }))] })))] })) }) })), _jsx("h2", Object.assign({ className: "star mt-56" }, { children: "\uC0C1\uC138\uB0B4\uC6A9" })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 mt-26 pt-24" }, { children: [_jsx("li", { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("div", Object.assign({ className: "h267" }, { children: _jsx(Editor, { value: content, 
                                                        // className="h267"
                                                        style: { height: "280px" }, theme: "snow", placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.", modules: modules, formats: formats, onChange: (_content, _delta, _source, editor) => setContent(editor.getHTML()) }) })) })) }), _jsx("li", Object.assign({ className: "mt-16" }, { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: "\uC0AC\uC9C4\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file4" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file4", accept: "image/*", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "\uC194\uB8E8\uC158 \uC0C1\uC138 \uD654\uBA74\uC5D0\uC11C \uD45C\uC2DC\uB418\uB294 \uC774\uBBF8\uC9C0\uB85C \uACE0\uD574\uC0C1\uB3C4 \uC774\uBBF8\uC9C0\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4. \uB4F1\uB85D\uB41C \uC774\uBBF8\uC9C0\uB294 \uB9AC\uC0AC\uC774\uC9D5 \uD574 \uBCF4\uC5EC\uC9D1\uB2C8\uB2E4. (\uAD8C\uC7A5 \uD06C\uAE30: 400KB\uC774\uC0C1/ \uD574\uC0C1\uB3C4 : 1500x1000 \uD53D\uC140 \uC774\uC0C1)" })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (_e) => onClickAttachFileDelete(idx, img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imagesAdd_" + idx.toString()))) }))] })) }))] }))] }))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (_e) => Close("pop-edit-card") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => CardSaved(e) }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] }));
}
function DeletePop(props) {
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const { item } = props;
    const [errorList, setErrorList] = useState([]);
    function Delete(_e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/energyconsulting/solution/${item.solutionId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    CUTIL.jsclose_Popup("pop-delete");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: CONST.ERROR_MSG }));
                    CUTIL.jsclose_Popup("pop-delete");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC194\uB8E8\uC158 \uCE74\uB4DC\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (_e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => Delete(e) }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] }));
}
